import { frontendURL } from '../../../helper/URLHelper';
import ConversionsView from './ConversionsView.vue';

const CONVERSIONS_PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/conversions'),
    name: 'conversions_view',
    meta: {
      permissions: CONVERSIONS_PERMISSIONS,
    },
    component: ConversionsView,
  },
];
